'use client';

import { Box, Typography } from '@coolblue-development/freddy';
import viewElementTrigger from '@coolblue-development/ga4-events/triggers/ProductSpecifications/viewElementTrigger';
import { TrackWhenVisible } from '@coolblue-development/next-analytics/client';
import PropertiesTable from '@features/product/components/Specifications/PropertiesTable';
import type { Property, PropertyGroup } from '@features/product/typings';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { useTranslation } from '@i18n/useTranslation';
import React, { useState } from 'react';

import FullSpecificationsLink from './FullSpecificationLink';
import SpecificationsModal from './SpecificationsModal';

type Props = {
  productId: number;
  productTypeId: number;
  properties: {
    summary: Property[];
    propertyGroups: PropertyGroup[];
  };
};

function ShortSpecifications({
  productId,
  productTypeId,
  properties: { summary, propertyGroups }
}: Props) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('webshop');
  const { isMobile } = useBreakpoints();
  const filteredProperties = summary.slice(0, isMobile ? 5 : 8);

  return (
    <TrackWhenVisible
      trigger={viewElementTrigger({
        sub_feature: 'short_specifications'
      })}
    >
      <Box>
        <Typography variant='h3'>{t('productPage.shortSpecifications')}</Typography>

        <PropertiesTable properties={filteredProperties} productTypeId={productTypeId} isShort />

        <FullSpecificationsLink onMobileClick={() => setOpen(true)}>
          {t('productPage.moreSpecifications')}
        </FullSpecificationsLink>

        {isMobile && (
          <SpecificationsModal
            productId={productId}
            open={open}
            onClose={() => setOpen(false)}
            propertyGroups={propertyGroups}
            productTypeId={productTypeId}
          />
        )}
      </Box>
    </TrackWhenVisible>
  );
}

export default ShortSpecifications;
